/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { browserHistory } from '@americanexpress/one-app-router';
import {
  Modal, ModalHeader, ModalBody, ModalFooter, ButtonPrimary, // eslint-disable-line no-unused-vars
} from '@americanexpress/dls-react';

const ActionModal = ({
  modalProp: {
    modalId, modalHeader, modalBody,
  }, toggleModal, componentPath,
}) => {
  const navigatePath = () => {
    browserHistory.push({
      pathname: componentPath,
    });
  };

  return (
    <Modal
      data-testid={modalId}
      onClose={toggleModal}
      theme={{
        '[role="dialog"]': {
          maxWidth: '820px',
          margin: 'auto',
        },
        '> div:first-of-type :focus': {
          outline: 'none !important',
          outlineOffset: '0px !important',
        },
      }}
    >
      <ModalHeader data-testid={`${modalId}-header`}>
        <h2 className="fluid heading-3">{modalHeader}</h2>
      </ModalHeader>
      <ModalBody data-testid={`${modalId}-body`}>
        <div className="pad-3 pad-4-b">
          {modalBody}
        </div>
      </ModalBody>
      <ModalFooter className="flex flex-align-center flex-justify-center">
        <ButtonPrimary data-testid={`${modalId}-navigation-btn`} onClick={navigatePath}>
          Launch
        </ButtonPrimary>
      </ModalFooter>
    </Modal>
  );
};

export default ActionModal;

ActionModal.propTypes = {
  modalProp: PropTypes.shape({
    modalId: PropTypes.string.isRequired,
    modalHeader: PropTypes.string.isRequired,
    modalBody: PropTypes.element.isRequired,
  }).isRequired,
  toggleModal: PropTypes.func.isRequired,
  componentPath: PropTypes.string.isRequired,
};
